export type LoyaltyReferralStatus =
  | "Success"
  | "Pending"
  | "Cancelled";

export type LoyaltyReferralIncentiveRecord = {
  id: string;
  serialNo: number;
  date: string;
  partnerNetworkId: string;
  partnerNetworkName: string;
  receivedIncentive: number;
  status: LoyaltyReferralStatus;
};

export const loyaltyReferralIncentivesData: LoyaltyReferralIncentiveRecord[] = [
  {
    id: "loyalty-ref-001",
    serialNo: 1,
    date: "2025-07-28",
    partnerNetworkId: "S89K5510",
    partnerNetworkName: "Siddharth",
    receivedIncentive: 25,
    status: "Success",
  },
  {
    id: "loyalty-ref-002",
    serialNo: 2,
    date: "2025-07-28",
    partnerNetworkId: "S89K5510",
    partnerNetworkName: "Siddharth",
    receivedIncentive: 25,
    status: "Success",
  },
  {
    id: "loyalty-ref-003",
    serialNo: 3,
    date: "2025-08-02",
    partnerNetworkId: "S89K5510",
    partnerNetworkName: "Siddharth",
    receivedIncentive: 50,
    status: "Pending",
  },
  {
    id: "loyalty-ref-004",
    serialNo: 4,
    date: "2025-08-11",
    partnerNetworkId: "S73M9042",
    partnerNetworkName: "Rahul",
    receivedIncentive: 75,
    status: "Success",
  },
  {
    id: "loyalty-ref-005",
    serialNo: 5,
    date: "2025-08-18",
    partnerNetworkId: "S18P7201",
    partnerNetworkName: "Arjun",
    receivedIncentive: 25,
    status: "Cancelled",
  },
  {
    id: "loyalty-ref-006",
    serialNo: 6,
    date: "2025-08-21",
    partnerNetworkId: "S46L8823",
    partnerNetworkName: "Meera",
    receivedIncentive: 50,
    status: "Success",
  },
  {
    id: "loyalty-ref-007",
    serialNo: 7,
    date: "2025-08-25",
    partnerNetworkId: "S89K5510",
    partnerNetworkName: "Siddharth",
    receivedIncentive: 25,
    status: "Success",
  },
  {
    id: "loyalty-ref-008",
    serialNo: 8,
    date: "2025-09-02",
    partnerNetworkId: "S64P1190",
    partnerNetworkName: "Priya",
    receivedIncentive: 100,
    status: "Success",
  },
  {
    id: "loyalty-ref-009",
    serialNo: 9,
    date: "2025-09-10",
    partnerNetworkId: "S22R3304",
    partnerNetworkName: "Vikram",
    receivedIncentive: 40,
    status: "Pending",
  },
  {
    id: "loyalty-ref-010",
    serialNo: 10,
    date: "2025-09-15",
    partnerNetworkId: "S91T6658",
    partnerNetworkName: "Kavya",
    receivedIncentive: 25,
    status: "Success",
  },
];
